<template>
    <div class="wrap">
        <CHeader :hideMenu="hideMenu" :isZhh="true" />
        <CFooter bALink="https://beian.miit.gov.cn/" bAName="浙ICP备20016534号-10" />
        <iframe :src="iframeSrc" frameborder="0" style="width:100%;height:100%;border:0;min-width: 1400px;"></iframe>
        <div class="liveBox" @click="goLive">
            <img  src="../../assets/zhibo.png" alt="" class="liveBox-img">
            <span class="liveBox-title">{{$t("exhibition").live}}</span>
        </div>
        <div class="liveBox living" @click="goLiving">
            <img src="../../assets/zhibo.png" alt="" class="liveBox-img">
            <div class="living-tip">
                <span class="tip">{{$t("exhibition").living_tip}}</span>
                <!-- <div class="liveBox-title">{{$t("exhibition").living}}</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import CHeader from "../exhibition/components/Headers";
import CFooter from "../exhibition/components/Footers";
import { mapState } from "vuex";

export default {
    data() {
        return {
            iframeSrc: '',
            hideMenu: false,
            isPavilion: true
        }
    },
    computed: {
        ...mapState(['userInfo', 'language'])
    },
    mounted() {
      debugger
        this.iframeSrc = `https://720.cloudvhall.com/shidai/${this.$route.query.exhibitionId}`
    },
    methods:{
        handleChangeIsPavilion() {
            this.isPavilion = !this.isPavilion
        },
        goIsHolding(_id) {
            this.$router.push({
                path: '/area/zhanqu',
                query:{
                    exhibition_id: _id,
                    status: '0',
                }
            })
        },
        goLive(){
            var tempwindow=window.open('_blank')
            tempwindow.location = 'https://meeting.cloudvhall.com/'
            
        },
        goLiving() {
            window.open('https://meeting.cloudvhall.com/#/meetingEntrance?url_token=Bf9kTbGnikGNMLGV&lang=zh-cn')
        }
    },
    components: {
        CHeader,
        CFooter
    },

}
</script>

<style lang="scss" scoped>
.wrap{
    min-width: 1400px;
    width: 100%; 
    height: 100vh;
    background-size: 100% 100%;
    position: relative;
    .liveBox{
        width: 84px;
        padding: 10px;
        background: #fff;
        border-radius: 10px;
        opacity: 0.69;       
        position: fixed;  
        right: 187px; 
        top: 130px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .liveBox-img{
            width: 32px;
            height: 32px;
        }
        .liveBox-title{
            margin-top:8px;
            font-size: 16px;
            font-weight: 500;
            color: #115FD3;
            line-height: 22px;
        }
        &.living {
            width: 202px;
            height: 80px;
            /* padding: 18px 12px 0; */
            flex-direction: row;
            align-items: center;
            right: 69px; 
            top: 240px;
            .living-tip {
                margin-left: 8px;
                .tip {
                    font-size: 14px;
                }
            }
            .liveBox-title {
                margin-top: 4px;
            }
            .liveBox-img {
                margin-top: -6px;
            }
        }
    }
    .show-pavilion{
        opacity: 0.7;
        position: absolute;
        top: 40%;
        left: 0;
        display: flex;
        align-items: center;
        z-index: 999;
        .show-pavilion-content{
            width: 280px;
            background: #ffffff;
            border-radius: 0px 20px 20px 0px;
            padding: 24px 24px 6px;
            .title{
                display: flex;
                align-items: center;
                .line{
                    width: 4px;
                    height: 20px;
                    background: #09468c;
                    margin-right: 4px;
                }
                .title-name{
                    font-size: 20px;
                    font-weight: 500;
                    color: #09468c;
                    line-height: 28px;
                }
            }
            .item{
                margin-top: 17px;
                .item-wrap{
                    margin-bottom: 18px;
                    cursor: pointer;
                    .item-name{
                        font-size: 14px;
                        text-align: left;
                        color: #333;
                        line-height: 22px;
                        font-weight: 400;
                        margin-bottom: 8px;
                    }
                    .item-time{
                        border: 1px solid #8390a8;
                        border-radius: 12px;
                        width: 99px;
                        height: 20px;    
                        font-size: 12px;   
                        color: #666;
                        line-height: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
        .hide-pavilion-content{
            display: flex;
            align-items: center;
            width: 20px;
            height: 80px;
            opacity: 0.7;
            background: #ffffff;
            border-radius: 0px 10px 10px 0px;
            cursor: pointer;
            .arrow-icon{
                color: #333;
            }
        }
    }
    .hide-pavilion{
        opacity: 0.7;
        position: absolute;
        top: 48%;
        left: 0;
        border-radius: 0px 10px 10px 0px;
        width: 20px;
        height: 80px;
        display: flex;
        background: #ffffff;
        align-items: center;
        cursor: pointer;
        .arrow-icon{
            color: #333;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/exhibitionView/index.vue